import React from "react";
import FileDownload from "js-file-download";
import { connect } from "react-redux";
import moment from "moment";
import { Scrollbars } from "react-custom-scrollbars";
import Loading from "../../system/components/Loading";
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Aux from "../../system/containers/Aux";
import Toolbar from "./components/Toolbar";
import PageHeader from "../../system/components/PageHeader";
import { WrappedTable, filterString } from "../../system/containers/Table";
import Http from "../../system/utils/Http";

import { actionCreators } from "../../store/newsletter";
import { reducers as newsletterSubscriptions } from "../../store/newsletter/actions";

const CheckboxTable = checkboxHOC(ReactTable);

const sourceLabels = {
  newsletter_form: "Newsletter Signup Form",
  enquiry_form: "Enquiry Form",
  contact_form: "Contact Form"
};

const formatSource = value => (value ? sourceLabels[value] || value : "");

const columns = [
  {
    accessor: "email",
    Header: "Email",
    filterMethod: filterString
  },
  {
    accessor: "first_name",
    Header: "First Name",
    filterMethod: filterString
  },
  {
    accessor: "last_name",
    Header: "Last Name",
    filterMethod: filterString
  },
  {
    accessor: "source",
    Header: "Source",
    filterMethod: filterString,
    Cell: props => formatSource(props.value)
  },
  {
    accessor: "consented_at.date",
    Header: "Consent Given",
    filterable: false,
    Cell: props => (props.value ? moment(props.value).format("LL @ LT") : "")
  }
];

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: []
    };
  }

  componentWillMount() {
    this.props.dispatch(actionCreators.fetchAll());
  }

  remove() {
    let items = this.props.selected;
    if (items.length === 0) {
      return alert("You have not selected any entries");
    }
    const result = window.confirm(
      "Are you sure you want to remove these entries?"
    );
    if (result) {
      this.props.dispatch(actionCreators.delete(items));
    }
  }

  export = () => {
    let items = this.props.selected;
    if (items.length === 0) {
      return alert("You haven't selected any subscriptions");
    }
    const result = window.confirm(
      "Are you sure these are the subscriptions you want to export"
    );

    if (result) {
      Http.post("/newsletter-subscriptions/export", {
        ids: items
      })
        .then(res => {
          FileDownload(res.data, "newsletter-subscriptions-report.csv");
        })
        .catch(err => {
          console.error(err);
        });
    }
  };

  render() {
    const { data, permissions, checkboxProps, loading } = this.props;
    if (loading) {
      return <Loading />;
    }
    return (
      <Aux>
        <PageHeader title="Newsletter Subscriptions" />
        <Toolbar
          permissions={permissions}
          total={data.length}
          handleDelete={() => this.remove()}
          export={() => this.export()}
        />
        <Scrollbars
          style={{ width: "100%", height: "100%", paddingBottom: "60px" }}
        >
          <CheckboxTable
            ref={r => (this.checkboxTable = r)}
            data={data}
            keyField="id"
            showPaginationBottom
            filterable
            columns={columns}
            loading={data.loading}
            defaultPageSize={20}
            style={{
              height: "100vh"
            }}
            className="-striped -highlight"
            {...checkboxProps}
          />
        </Scrollbars>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    data: store.newsletterSubscriptions.list,
    loading: store.newsletterSubscriptions.loading
  };
}

const WrapTable = WrappedTable(List);

export default connect(mapStateToProps)(WrapTable);



// WEBPACK FOOTER //
// ./src/containers/NewsletterSubscriptions/List.jsx